import React, { useMemo, useEffect } from "react";
import { Label, FormFeedback, FormGroup } from "reactstrap";
import Select from "react-select";
import { useDispatch } from "react-redux";

import { getPerformanceRatingTypes } from "common/services/performance-rating.service";
import { normalize } from "common/lib/normalize";
import { filterSelectStyles } from "Components/Common/TableFilters";
import {
  RatingOptionLabel,
  ratingTypeOption,
} from "Components/Common/PerformanceRatingTone";

const SelectPerformanceRatingType = ({
  validation,

  label,
}: {
  validation: any;

  label?: string;
}) => {
  // Same theme-aware look as the other rating dropdowns, with a coral border
  // once the field has an error.
  const invalid = !!(
    validation.touched?.performanceRatingType &&
    validation.errors?.performanceRatingType
  );
  const customSelectStyles = {
    ...filterSelectStyles,
    control: (provided: any, state: any) => ({
      ...filterSelectStyles.control(provided, state),
      borderColor: invalid
        ? "var(--vz-form-invalid-border-color)"
        : state.isFocused
        ? "var(--vz-primary-border-subtle)"
        : "var(--vz-input-border-custom)",
    }),
  };

  const dispatch: any = useDispatch();

  const [data, setData] = React.useState([]);
  const [, setError] = React.useState(null);
  const [loading, setLoading] = React.useState(false);

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      try {
        const response = await getPerformanceRatingTypes({});
        setData(normalize(response.data));
        setError(null);
      } catch (err: any) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [dispatch, setLoading]);

  const options = useMemo(() => data.map(ratingTypeOption), [data]);

  return (
    <FormGroup>
      <Label htmlFor={`performanceRatingType`} className="form-label">
        {label ? label : "Performance Rating"}
      </Label>
      <Select
        name={`performanceRatingType`}
        id={`performanceRatingType`}
        value={
          validation.values?.performanceRatingType?.value
            ? validation.values?.performanceRatingType
            : null
        }
        placeholder="Select rating"
        onChange={(value: any) => {
          validation.setFieldValue(`performanceRatingType`, value);
          validation.setFieldError(`performanceRatingType`, "");
        }}
        options={options}
        formatOptionLabel={RatingOptionLabel}
        onBlur={() => validation.setFieldTouched(`performanceRatingType`, true)}
        className={
          validation.touched?.performanceRatingType &&
          validation.errors?.performanceRatingType
            ? "is-invalid"
            : ""
        }
        styles={customSelectStyles}
        isLoading={loading}
      />
      <FormFeedback>
        {validation.errors?.performanceRatingType?.value || ""}
      </FormFeedback>
    </FormGroup>
  );
};

export default SelectPerformanceRatingType;
